var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.775 13.7324C15.7483 13.7324 14.9417 14.5574 14.9417 15.5658C14.9417 16.5741 15.7667 17.3991 16.775 17.3991C17.7833 17.3991 18.6083 16.5741 18.6083 15.5658C18.6083 14.5574 17.7833 13.7324 16.775 13.7324Z",
    fill: "#14141F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3433 9.24033C37.8033 5.66533 34.4116 3.66699 29.6816 3.66699H14.3183C8.43329 3.66699 3.66663 8.43366 3.66663 14.3187V29.682C3.66663 34.412 5.66496 37.8037 9.23996 39.3437C9.58829 39.4903 9.99163 39.3987 10.2483 39.142L39.1416 10.2487C39.4166 9.97366 39.5083 9.57033 39.3433 9.24033ZM19.305 22.4403C18.59 23.137 17.655 23.467 16.72 23.467C15.785 23.467 14.85 23.1187 14.135 22.4403C12.265 20.6803 10.2116 17.8753 11 14.5387C11.6966 11.5137 14.3733 10.157 16.72 10.157C19.0666 10.157 21.7433 11.5137 22.44 14.557C23.21 17.8753 21.1566 20.6803 19.305 22.4403Z",
    fill: "#14141F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.695 37.638C36.0983 38.0413 36.0433 38.7013 35.5483 38.9763C33.935 39.8746 31.9733 40.333 29.6816 40.333H14.3183C13.7866 40.333 13.5666 39.7096 13.9333 39.343L25.0066 28.2696C25.3733 27.903 25.9416 27.903 26.3083 28.2696L35.695 37.638Z",
    fill: "#14141F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3334 14.3183V29.6816C40.3334 31.9733 39.875 33.9533 38.9767 35.5483C38.7017 36.0433 38.0417 36.08 37.6384 35.695L28.2517 26.3083C27.885 25.9416 27.885 25.3733 28.2517 25.0066L39.325 13.9333C39.71 13.5666 40.3334 13.7866 40.3334 14.3183Z",
    fill: "#14141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoTwo);
export default __webpack_public_path__ + "static/media/trvto_Two.62a8bad87e8d038770c77db5223e339a.svg";
export { ForwardRef as ReactComponent };